export default __webpack_public_path__ + "static/equipment-reference-512a2a3450928149e234f765fc9f08e0.jpg";